import {
    IActionComparator,
    INamespaceActionCreator,
    IReducer,
} from '@omaze/redux';
import { AnyAction } from 'redux';

import { FEATURE_FLAG_ACTIONS } from '../../FeatureFlag.actions';
import {
    createFeatureFlagActionComparator,
    createFeatureFlagActionCreatorFactory,
    createFeatureFlagReducerFactory,
} from '../../FeatureFlag.factory';
import { IFeatureFlagState } from '../../FeatureFlag.state';

export const createEnableAction: INamespaceActionCreator = createFeatureFlagActionCreatorFactory(
    FEATURE_FLAG_ACTIONS.ENABLE,
    (flag: string): string => {
        return flag;
    },
);

export const enableActionReducer: IReducer<IFeatureFlagState> = createFeatureFlagReducerFactory(
    FEATURE_FLAG_ACTIONS.ENABLE,
    (state: IFeatureFlagState, action: AnyAction): void => {
        state.flags[action.payload] = true;
    },
);

export const enableActionComparator: IActionComparator = createFeatureFlagActionComparator(
    FEATURE_FLAG_ACTIONS.ENABLE,
);
